import React from 'react';
import {
  Box,
  Flex,
  ModalBody,
  ModalCloseButton,
  ModalContent as ChakraModalContent,
} from '@chakra-ui/react';

import ModalContentSection from './ContentSection';
import TickIcon from '../icons/TickIcon';
import PadlockIcon from '../icons/PadlockIcon';
import ImpactGraphic from '../ImpactGraphic';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import { ImpactUpsellContent, ImpactUpsellIconType } from '../../text-content';
import { ImpactUpsellIcon } from '../icons/ImpactUpsellIcon';

const sectionIcons: Record<ImpactUpsellIconType, ImpactUpsellIcon> = {
  tick: TickIcon,
  padlock: PadlockIcon,
};

const ModalContent = (props: {
  text: ImpactUpsellContent;
  onDismiss: () => void;
  variant: 'details' | 'overview';
}) => (
  <ChakraModalContent
    backgroundColor="transparent"
    boxShadow="none"
    margin={0}
    height="100%"
    minH="auto"
    display="block"
    containerProps={{
      position: 'absolute',
      inset: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100%',
    }}
  >
    <Box
      position="absolute"
      inset={0}
      overflowY="auto"
      overflowX="hidden"
      display="flex"
      flexDirection="column"
      pointerEvents="auto"
      px={5}
      pb={4}
    >
      <Box flex="1 0 auto" minH={4} aria-hidden />

      <Box
        position="relative"
        display="flex"
        flexDirection="row"
        flexShrink={0}
        width="100%"
        maxW={{ md: '6xl' }}
        minH={{ md: 'min(38rem, calc(100% - 2rem))' }}
        mx="auto"
        overflow="hidden"
        backgroundColor="#000000"
        borderRadius="2xl"
        color="#F9F9F9"
        fontFamily="Open Sans"
        paddingLeft={8}
        paddingY={5}
        paddingRight={{ base: 8, md: 0 }}
      >
        {props.variant === 'overview' && (
          <ModalCloseButton _focus={{ boxShadow: 'none' }} />
        )}

        <Flex direction="column" flex={100} minW={0}>
          <ModalHeader {...props.text.header} />

          <ModalBody pt={0} flex="0 0 auto">
            {props.text.contentSections.map((section) => (
              <ModalContentSection
                key={section.sectionReference}
                sectionReference={section.sectionReference}
                title={section.title}
                bullets={section.bullets}
                icon={sectionIcons[section.icon]}
              />
            ))}
          </ModalBody>

          <Box flex="1 1 auto" minH={0} aria-hidden />

          <ModalFooter
            ctaButton={props.text.buttons.cta}
            dismissButton={{
              text: props.text.buttons.dismiss,
              onClick: props.onDismiss,
            }}
          />
        </Flex>

        <ImpactGraphic widthRatio={props.variant === 'overview' ? 45 : 40} />
      </Box>

      <Box flex="1 0 auto" minH={4} aria-hidden />
    </Box>
  </ChakraModalContent>
);

export default ModalContent;
